import axios from '../utils/axios';

export async function getUsers(): Promise<any[]> {
  return axios.get('/users').then((res) => res.data);
}

export async function getUser(userId: string): Promise<any> {
  return axios.get(`/users/${userId}`).then((res) => res.data);
}

export async function createUser(user: any): Promise<any> {
  return axios.post('/users', user).then((res) => res.data);
}

export async function updateUser(userId: string, user: any): Promise<any> {
  return axios.put(`/users/${userId}`, user).then((res) => res.data);
}

export async function deleteUser(userId: string): Promise<any> {
  return axios.delete(`/users/${userId}`).then((res) => res.data);
}
